var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.017 3.66094C0.870743 4.80899 1.68577 5.89443 2.78836 6.2169C4.06218 6.58945 5.52017 6.97865 7.0158 7.35833C7.61636 8.54697 8.24638 9.69563 8.7173 10.532C9.15196 11.304 10.0649 11.7634 10.9207 11.6584C11.8992 11.5383 12.4956 10.7208 12.2749 9.7809C12.1886 9.41314 12.0902 9.00121 11.9826 8.56277C13.5704 8.93293 14.9944 9.25281 16.0388 9.48385C16.9509 9.68565 17.8011 9.14813 18.042 8.26792C18.0605 8.22292 18.0767 8.17626 18.0905 8.12806C18.443 6.89463 18.7559 5.38254 18.9674 4.26397C19.1398 3.35162 18.6133 2.43476 17.7508 2.10677C16.8883 1.77879 15.9475 2.13769 15.5546 2.96621C15.2845 3.53574 14.9678 4.22339 14.6644 4.92934C12.1819 3.8254 8.82457 2.38195 5.89323 1.29235C3.72906 0.487914 1.30951 1.36484 1.017 3.66094Z",
    fill: "#84C70D",
    fillOpacity: 0.3,
    stroke: "#84C70D",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6719 15.8574L1.32145 15.8574",
    stroke: "#84C70D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.e1939eeaf991f8136ecc352c5f62eb4a.svg";
export { ForwardRef as ReactComponent };